__turbopack_context__.v({
  "graph": "Outputs-module-scss-module__pqyI-W__graph",
  "swipeHint": "Outputs-module-scss-module__pqyI-W__swipeHint",
});
